function calculateHeight({ctx, text, maxWidth, lineHeight}) {
    const words = text.split(' ');
    let line = '';
    let height = 0;

    for(var n = 0; n < words.length; n++) {
      const testLine = line + words[n] + ' ';
      const { width } = ctx.measureText(testLine);
      if (width > maxWidth && n > 0) {
        line = words[n] + ' ';
        height += lineHeight;
      }
      else {
        line = testLine;
      }
    }

    return height;

}

// function that splits long text onto multiple lines
function wrapText(ctx, text, { x, y, maxWidth, lineHeight }) {

    var words = text.split(' ');
    var line = '';  

    for(var n = 0; n < words.length; n++) {
      var testLine = line + words[n] + ' ';
      var metrics = ctx.measureText(testLine);
      var testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        ctx.fillText(line, x, y);
        line = words[n] + ' ';
        y += lineHeight;
      }
      else {
        line = testLine;
      }
    }

    ctx.fillText(line, x, y);
}